import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { accountLanguageSchema } from '../schemas/account-language.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Defines the Language for the account
 * @param languageId The id of the language to set
 * @returns Data object containing the newly assigned Language
 */
export function postPreferencesAccountLanguage(
  this: unknown,
  languageId: string
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        accountsEnvironment.resolve(this).preferencesAccountLanguageUrl,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({ languageId }),
        }
      )
    )
  ).pipe(selectData(accountLanguageSchema));
}
